<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <PageHeader :content="page.data.header">
          <ToggleSelector :toggles="[$t('event.future'), $t('event.past')]" @toggleChange="toggleChange" />
        </PageHeader>
        <SearchBar v-model="search" />
        <FeedList :items="items as Event[]" />
        <PageSections :sections="page.data.sections ?? []" />
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {SearchBar} from '@/components/blocks'
import {ViewDataMixin} from '@/views/mixins'
import {FeedList, PageHeader, PageSections} from '@/components/sections'
import {ToggleSelector} from '@/components/small'
import {useEventStore, usePageStore} from '@/stores'
import {useSearch} from '@/composables'
import {ref} from 'vue'

export default {
  name: 'EventIndex',
  mixins: [ViewDataMixin],
  components: {FeedList, PageHeader, PageSections, SearchBar, ToggleSelector},
  setup() {
    const events = ref<any[]>([]) // Using any[] to allow additional properties
    const filteredEvents = ref<Event[]>([])
    const { search, items } = useSearch(filteredEvents)
    return { search, items, events, filteredEvents }
  },
  data() {
    return {
      page: null as Page | null,
      feedListOpacity: 1
    }
  },
  methods: {
    async init() {
      const [page, events] = await Promise.all([usePageStore().get("events"), useEventStore().all()])

      if (!page) {
        return await this.$router.push({ name: this.$routes.NOT_FOUND })
      }

      this.page = page
      this.events = events.map((event) => ({
        ...event,
        _startTimestamp: new Date(event.start_date).getTime(),
        _endTimestamp: new Date(event.end_date).getTime(),
      }))

      this.toggleChange(false)
    },
    async toggleChange(isPast: boolean) {
      this.feedListOpacity = 0

      const startOfDay = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      this.filteredEvents = this.events
        .filter((event) => {
          return isPast ? event._endTimestamp <= startOfDay : event._endTimestamp > startOfDay
        })
        .sort((eventA, eventB) =>
          isPast ? eventB._startTimestamp - eventA._startTimestamp : eventA._startTimestamp - eventB._startTimestamp
        )

      this.feedListOpacity = 1
    },
  },
}
</script>
